import { render, staticRenderFns } from "./ManualRunes.vue?vue&type=template&id=35f1dd82&"
import script from "./ManualRunes.vue?vue&type=script&lang=js&"
export * from "./ManualRunes.vue?vue&type=script&lang=js&"
import style0 from "./ManualRunes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports